import React, { ReactNode } from 'react'
import styles from './Error.module.scss'
import classNames from 'classnames'

interface ErrorProps {
  children: ReactNode
  alt?: boolean
}

const Error: React.FC<ErrorProps> = ({ children, alt = false }) => {
  return (
    <div
      className={classNames(styles.error, {
        [styles.altError]: alt,
      })}
    >
      {children}
    </div>
  )
}

export default Error
